/**
 * @generated SignedSource<<a954875a58c1aa677f7f53b1e1766809>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespRefetchableSimilarItemsGrid_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsGrid_user">;
  readonly " $fragmentType": "PdpRespRefetchableSimilarItemsGrid_user";
};
export type PdpRespRefetchableSimilarItemsGrid_user$key = {
  readonly " $data"?: PdpRespRefetchableSimilarItemsGrid_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespRefetchableSimilarItemsGrid_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespRefetchableSimilarItemsGrid_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "c3a553d8f3d1aa02a1df4eb070631d80";

export default node;
